<template>
  <div class="feed-screen">
    <page-header :title="$t('app.feeds.title')"/>
    <div class="row mt-20 mb-20">
      <div class="col-sm-12 text-right">
        <base-button
          v-if="loggedInUser.role === 'admin' || loggedInUser.role === 'partner_admin'"
          :title="$t('app.feeds.create_title')"
          classNames="btn btn-orange rounded pull-right"
          @clicked="addNewsFeed"
        />
      </div>
    </div>
    <div class="panel-wrapper collapse in">
      <div v-if="newsFeeds && newsFeeds.feeds && newsFeeds.feeds.length > 0" class="panel-body">
        <div class="streamline">
          <feed-card 
            v-for="(feed,index) in newsFeeds.feeds"
            :key="index"
            :feed="feed"
            :needActionButtons="loggedInUser.role === 'admin' || loggedInUser.role === 'partner_admin'"
            @editFeedClicked="editFeedClicked"
            @deleteFeedClicked="deleteFeedClicked"
            />
        </div>
      </div>
      <div v-else-if="newsFeeds && newsFeeds.feeds && newsFeeds.feeds.length === 0">
        <div class="row mt-20 mb-10">
          <div class="col-sm-6">
            <span>{{$t('app.feeds.noResult')}}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row mt-20 mb-10">
          <div class="col-sm-6">
            <span>{{$t('app.feeds.loading')}}</span>
          </div>
        </div>
      </div>
      <paginator-component
        v-if="newsFeeds && newsFeeds.feeds && newsFeeds.feeds.length > 0"
        :totalPages="totalPages"
        :currentPageIndex="currentPageIndex"
        @itemSelected="itemSelected"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BaseButton from "@/components/shared/buttons/BaseButton";
import FormInput from "@/components/shared/inputs/FormInput";
import PageHeader from "@/components/shared/layouts/PageHeader";
import Paginator from "@/components/shared/navigations/Paginator";
import FeedCard from "./FeedCard";
import GenericForm from "@/components/shared/forms/GenericForm";


export default {
  name: "FeedScreen",
  components: {
    "base-button": BaseButton,
    "form-input": FormInput,
    "page-header": PageHeader,
    "paginator-component": Paginator,
    "feed-card": FeedCard,
  },
  props: {
  },
  data() {
    return {
      currentPageIndex: 1,
      newMessage: '',
      newsFeeds: [],
      selectedFeed: null,
      fields: [
        {
          name: "message",
          type: "text-area",
          classes: "col-md-12"
        },
      ],
      newFeed: {
        message: ''
      },
      feedAttributes: [
        {
          name: "message",
          type: "text-area",
          classes: "col-md-12"
        },
      ]
    };
  },
  created() {
    this.fetchFeeds({
      pageIndex: this.currentPageIndex,
      id: this.loggedInUser.id
    }).then(response => {
      this.newsFeeds = response
    })

  },
  computed: {
    ...mapGetters({
      loggedInUser: "loggedInUser",
    }),
    totalPages() {
      return this.newsFeeds.total_pages || 0;
    },
  },
  methods: {
    ...mapActions({
      fetchFeeds: "users/fetchFeeds",
      createNewFeed: "users/createFeed",
      updateSelectedFeed: "users/updateFeed",
      deleteFeed: "users/deleteFeed",
      fetchFeed: "users/fetchFeed",
    }),
    itemSelected(index) {
      this.currentPageIndex = index;
    },
    addNewsFeed() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t("app.feeds.create_title"),
          fields: this.fields,
          model: this.newFeed,
          submitTitle: this.$t("app.feeds.buttons.save"),
          cancelTitle: this.$t("app.feeds.buttons.cancel"),
          modelName: "feeds"
        },
        on: {
          submit: this.createFeed,
          modalCanceled: this.resetNewFeed
        }
      });
    },
    createFeed(newFeed) {
     if(newFeed.message && newFeed.message.length > 255) {
       this.$swal
        .fire({
          html: this.$t('app.feeds.lengthError'),
          type: "error",
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          focusConfirm: false,
        })
        this.$eventBus.stopLoading()
     } else {
       this.createNewFeed({id: this.loggedInUser.id, params: newFeed}).then(response => {
         this.$eventBus.showNotification({
             notificationText: this.$t("app.feeds.success.create"),
             notificationType: "success"
           });
         this.fetchFeeds({
           pageIndex: this.currentPageIndex,
           id: this.loggedInUser.id
         }).then(response => {
           this.newsFeeds = response
           this.$eventBus.hideModal();
           this.resetNewFeed()
         }).catch(error => {
           this.$eventBus.stopLoading()
           this.$swal
               .fire({
                 html: error[0],
                 type: "error",
                 showCloseButton: true,
                 showCancelButton: false,
                 showConfirmButton: false,
                 focusConfirm: false,
               })
         });
       }).catch(error => {
         this.$eventBus.stopLoading()
         this.$swal
               .fire({
                 html: error[0],
                 type: "error",
                 showCloseButton: true,
                 showCancelButton: false,
                 showConfirmButton: false,
                 focusConfirm: false,
               })
         });
     }
    },
    resetNewFeed() {
      Object.assign(this.$data.newFeed, this.$options.data().newFeed);
    },
    editFeedClicked(id) {
      this.editFeed(id);
    },
    editFeed(id) {
      this.fetchFeed({id: this.loggedInUser.id, feedId: id}).then(feed => {
        this.$eventBus.showModal({
          bind: {
            is: GenericForm,
            title: this.$t("app.feeds.update_title"),
            fields: this.feedAttributes,
            model: feed,
            submitTitle: this.$t("app.feeds.buttons.save"),
            cancelTitle: this.$t("app.feeds.buttons.cancel"),
            modelName: "feeds"
          },
          on: {
            submit: this.updateFeed
          },
        });
      });
    },
    updateFeed(feed) {
      if(feed.message && feed.message.length > 255) {
       this.$swal
        .fire({
          html: this.$t('app.feeds.lengthError'),
          type: "error",
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: false,
          focusConfirm: false,
        })
        this.$eventBus.stopLoading()
     } else {
       this.updateSelectedFeed({id: this.loggedInUser.id, params: feed})
         .then(response => {
           this.fetchFeeds({
             pageIndex: this.currentPageIndex,
             id: this.loggedInUser.id
           }).then(response => {
             this.newsFeeds = response
           });
           this.$eventBus.hideModal();
         })
         .catch(error => {
           this.$eventBus.stopLoading()
           this.$swal
               .fire({
                 html: error[0],
                 type: "error",
                 showCloseButton: true,
                 showCancelButton: false,
                 showConfirmButton: false,
                 focusConfirm: false,
               })
         });
     }
    },
    deleteFeedClicked(id) {
      this.$swal
        .fire({
          html: this.$t("app.notifications.general_confirm.title"),
          type: "info",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t("app.notifications.general_confirm.ok"),
          cancelButtonText: this.$t("app.notifications.general_confirm.cancel")
        })
        .then(result => {
          if (result.value) {
            this.deleteFeed({id: this.loggedInUser.id, feedId: id}).then(response => {
              this.fetchFeeds({
                pageIndex: this.currentPageIndex,
                id: this.loggedInUser.id
              }).then(response => {
                this.newsFeeds = response
              });
            })
            .catch(error => {
                this.$swal
              .fire({
                html: error[0],
                type: "error",
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              })
            });
          }
        })
    }
  },
  watch: {
    currentPageIndex(newValue, oldValue) {
      this.fetchFeeds({
        pageIndex: newValue,
        id: this.loggedInUser.id
      }).then(response => {
        this.newsFeeds = response
      })

    }
  }
};
</script>

<style lang="scss" scoped>

.panel-body {
  background: white;
  margin-bottom: 40px;
}

/deep/ .rounded {
  border-radius: 4px;
}

/deep/ .sl-avatar {
  left: -35px !important;
  background: white;
}

/deep/ .sl-content {
  .inline-block, .block {
    margin-left: 50px;
  }
}

/deep/ .sl-item {
  margin-left: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/helpdesk/FeedScreen.vue